import { createCardAward } from '@lc/interface/card/award/factory';

// TODO add a "target Id" to... no we need to have an interactive messaging point during award and contract resolution
export const AwardMeta = [
	createCardAward(
		0,
		`MAKE THE BEST COMMERCIAL DURING THE PUPPY BOWL`,
		`HAVE THE MOST CARBON IN YOUR CARBON FOOTPRINT`,
		`PLACE A CARBON FROM YOUR CARBON FOOTPRINT INTO A NEIGHBOR’S CARBON FOOTPRINT FOR EACH BATTERY YOU HAVE`,
		// true,
		// false,
		true
	),
	createCardAward(
		1,
		`PARTICIPATION TROPHY`,
		`HAVE THE MOST PR`,
		`WINNER RECHARGES ALL BATTERIES`
	),
	createCardAward(
		2,
		`WIN ‘AMERICA’S GOT POWER’`,
		`HAVE THE MOST PR`,
		`WINNER RECHARGES ALL BATTERIES AND GAINS A BATTERY`
	),
	createCardAward(
		3,
		`ENERGY ENTREPRENEUR OF THE YEAR`,
		`HAVE THE MOST INCOMPLETE CONTRACTS`,
		`TAKE A BATTERY FROM A NEIGHBOR`,
		// true,
		// false,
		true
	),
	createCardAward(
		4,
		`LEAVE NO TRACE`,
		`HAVE THE LOWEST CARBON FOOTPRINT`,
		`GIVE ALL CARBON FROM YOUR FOOTPRINT INTO A NEIGHBOR'S FOOTPRINT`,
		// true,
		// false,
		true
	),
	createCardAward(
		5,
		`FREE PEDICURE`,
		`HAVE THE LOWEST CARBON FOOTPRINT`,
		`GIVE ALL CARBON FROM YOUR FOOTPRINT INTO A NEIGHBOR'S FOOTPRINT`,
		true
	),
	createCardAward(
		6,
		`JUMP STARTER`,
		`HAVE THE MOST BATTERIES`,
		`TAKE A BATTERY FROM A NEIGHBOR`,
		true
	),
];
